import React from 'react';
export const ContainerCrane = () => (
  <svg width="138px" height="112px" viewBox="0 0 138 112" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-257.000000, -1471.000000)">
        <g transform="translate(258.000000, 1471.000000)">
          <path
            d="M109.7779,111.1596 L135.5229,111.1596"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.4492,111.1596 L13.1942,111.1596"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M63.6099,35.6117 L80.2829,43.2707"
            stroke="#ED0722"
            strokeLinecap="round"
          />
          <path
            d="M60.3697,33.1635 C60.3697,34.9795 61.8417,36.4515 63.6577,36.4515 C65.4737,36.4515 66.9457,34.9795 66.9457,33.1635 C66.9457,31.3485 65.4737,29.8755 63.6577,29.8755 L63.6577,26.2385"
            stroke="#391572"
            strokeLinecap="round"
          />
          <path
            d="M47.8223,43.2709 L63.6103,35.6119"
            stroke="#ED0722"
            strokeLinecap="round"
          />
          <polygon
            fill="#FFFFFF"
            points="66.9458 26.2387 60.3698 26.2387 61.2808 22.4537 66.0338 22.4537"
          />
          <polygon
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="66.9458 26.2387 60.3698 26.2387 61.2808 22.4537 66.0338 22.4537"
          />
          <g transform="translate(43.000000, 42.710000)">
            <polyline
              fill="#FFFFFF"
              points="0.3413 3.9086 0.3413 0.5606 40.8783 0.5606 40.8783 20.9066 0.3413 20.9066 0.3413 8.9706"
            />
            <polyline
              stroke="#391572"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.3413 3.9086 0.3413 0.5606 40.8783 0.5606 40.8783 20.9066 0.3413 20.9066 0.3413 8.9706"
            />
          </g>
          <path
            d="M50.5039,50.3588 L50.5039,58.6388"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M55.4253,52.6733 L55.4253,55.9323"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M60.7329,50.3588 L60.7329,58.6388"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M65.6548,52.6733 L65.6548,55.9323"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M71.6192,50.3588 L71.6192,58.6388"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M76.541,52.6733 L76.541,55.9323"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <g transform="translate(61.000000, 0.710000)">
            <polyline
              fill="#FFFFFF"
              points="11.5757 5.6908 4.6747 0.7088 0.9047 5.9298 71.0837 59.6528"
            />
            <polyline
              stroke="#757575"
              strokeLinecap="round"
              points="11.5757 5.6908 4.6747 0.7088 0.9047 5.9298 71.0837 59.6528"
            />
          </g>
          <g transform="translate(76.000000, 8.710000)">
            <path d="M56.5967,41.0228 L0.5217,0.5408" fill="#FFFFFF" />
            <path
              d="M56.5967,41.0228 L0.5217,0.5408"
              stroke="#757575"
              strokeLinecap="round"
            />
          </g>
          <g transform="translate(63.000000, 0.710000)">
            <path d="M0.6099,21.7435 L0.6099,0.7085" fill="#FFFFFF" />
            <path
              d="M0.6099,21.7435 L0.6099,0.7085"
              stroke="#391572"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M66.9458,4.141 C66.9458,5.957 65.4738,7.429 63.6578,7.429 C61.8418,7.429 60.3698,5.957 60.3698,4.141 C60.3698,2.326 61.8418,0.853 63.6578,0.853 C65.4738,0.853 66.9458,2.326 66.9458,4.141"
            fill="#FFFFFF"
          />
          <path
            d="M66.9458,4.141 C66.9458,5.957 65.4738,7.429 63.6578,7.429 C61.8418,7.429 60.3698,5.957 60.3698,4.141 C60.3698,2.326 61.8418,0.853 63.6578,0.853 C65.4738,0.853 66.9458,2.326 66.9458,4.141 Z"
            stroke="#757575"
            strokeLinecap="round"
          />
          <g transform="translate(50.000000, 81.710000)">
            <polyline
              fill="#F3F4F6"
              points="13.9507 0.4486 44.3597 0.4486 44.3597 25.4496 0.6607 25.4496 0.6607 0.4486 5.8557 0.4486"
            />
            <polyline
              stroke="#DDE5E8"
              points="13.9507 0.4486 44.3597 0.4486 44.3597 25.4496 0.6607 25.4496 0.6607 0.4486 5.8557 0.4486"
            />
          </g>
          <g transform="translate(26.000000, 91.710000)">
            <polyline
              fill="#FFFFFF"
              points="9.9634 0.3988 32.4124 0.3988 32.4124 15.4498 0.1934 15.4498 0.1934 0.3988 4.0964 0.3988"
            />
            <polyline
              stroke="#DDE5E8"
              strokeLinecap="round"
              points="9.9634 0.3988 32.4124 0.3988 32.4124 15.4498 0.1934 15.4498 0.1934 0.3988 4.0964 0.3988"
            />
          </g>
          <polygon
            fill="#FFFFFF"
            points="21.125 111.38 99.848 111.38 99.848 107.159 21.125 107.159"
          />
          <polygon
            stroke="#DDE5E8"
            strokeLinecap="round"
            points="21.125 111.38 99.848 111.38 99.848 107.159 21.125 107.159"
          />
          <path
            d="M65.1656,4.141 C65.1656,4.974 64.4906,5.649 63.6576,5.649 C62.8256,5.649 62.1496,4.974 62.1496,4.141 C62.1496,3.309 62.8256,2.633 63.6576,2.633 C64.4906,2.633 65.1656,3.309 65.1656,4.141"
            fill="#757575"
          />
          <g transform="translate(51.000000, 84.710000)">
            <path d="M0.2451,0.4486 L43.3591,0.4486" fill="#FFFFFF" />
            <path
              d="M0.2451,0.4486 L43.3591,0.4486"
              stroke="#DDE5E8"
              strokeLinecap="round"
            />
          </g>
          <path
            d="M45.3413,46.1723 L82.1543,46.1723"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <polygon
            fill="#DDE5E8"
            points="64.3155 23.2221 64.1825 25.3001 65.8345 25.3001 65.4615 23.2331"
          />
          <polygon
            fill="#F3F4F6"
            points="104.479 37.4701 112.778 37.4701 131.702 51.6731 131.702 57.9791"
          />
          <path
            d="M66.9458,8.4779 L111.3728,42.1239"
            stroke="#F3F4F6"
            strokeLinecap="round"
          />
          <path
            d="M100.6968,34.0385 L106.6358,34.0385"
            stroke="#F3F4F6"
            strokeLinecap="round"
          />
          <path
            d="M96.937,30.6557 L102.135,30.6557"
            stroke="#F3F4F6"
            strokeLinecap="round"
          />
          <path
            d="M131.7022,51.6733 L70.1092,6.6203"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M56.3941,85.1586 L56.3941,92.1086"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M62.7471,85.1586 L62.7471,107.1596"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <g transform="translate(96.000000, 9.710000)">
            <path
              d="M15.6817,3.7035 C14.9387,3.0235 13.9667,3.1765 13.9667,3.1765 C13.9667,3.1765 14.3667,1.4945 11.7377,0.7295 C9.1077,-0.0345 7.9647,1.5795 7.9647,1.5795 C6.5357,0.5595 5.4497,1.7495 4.9347,2.5145 C4.4207,3.2785 4.0197,4.0435 2.3627,4.2135 C0.7047,4.3835 0.5337,5.8275 0.5337,5.8275 L18.3727,5.8275"
              fill="#FFFFFF"
            />
            <path
              d="M15.6817,3.7035 C14.9387,3.0235 13.9667,3.1765 13.9667,3.1765 C13.9667,3.1765 14.3667,1.4945 11.7377,0.7295 C9.1077,-0.0345 7.9647,1.5795 7.9647,1.5795 C6.5357,0.5595 5.4497,1.7495 4.9347,2.5145 C4.4207,3.2785 4.0197,4.0435 2.3627,4.2135 C0.7047,4.3835 0.5337,5.8275 0.5337,5.8275 L18.3727,5.8275"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M69.1006,85.1586 L69.1006,107.1596"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M75.4536,85.1586 L75.4536,107.1596"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M81.8072,85.1586 L81.8072,107.1596"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M88.1602,85.1586 L88.1602,107.1596"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <g transform="translate(2.000000, 19.710000)">
            <path
              d="M30.0337,7.0238 C28.5747,5.6178 26.6657,5.9318 26.6657,5.9318 C26.6657,5.9318 27.4507,2.4538 22.2867,0.8718 C17.1217,-0.7102 14.8757,2.6288 14.8757,2.6288 C12.0697,0.5198 9.9357,2.9808 8.9257,4.5628 C7.9147,6.1448 7.1287,7.7268 3.8727,8.0788 C0.6167,8.4298 0.2807,11.4188 0.2807,11.4188 L35.3197,11.4188"
              fill="#FFFFFF"
            />
            <path
              d="M30.0337,7.0238 C28.5747,5.6178 26.6657,5.9318 26.6657,5.9318 C26.6657,5.9318 27.4507,2.4538 22.2867,0.8718 C17.1217,-0.7102 14.8757,2.6288 14.8757,2.6288 C12.0697,0.5198 9.9357,2.9808 8.9257,4.5628 C7.9147,6.1448 7.1287,7.7268 3.8727,8.0788 C0.6167,8.4298 0.2807,11.4188 0.2807,11.4188 L35.3197,11.4188"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(41.000000, 30.710000)">
            <path d="M0.0996,0.4183 L4.8226,0.4183" fill="#FFFFFF" />
            <path
              d="M0.0996,0.4183 L4.8226,0.4183"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
